import { commonMenuItems } from "./common";
import defaultProfile from "./default";
import type { ConfigSection, GameProfile, Menu, ProfileCtx } from "./types";

const WHITELIST_ENABLED_KEY = "/Script/TheIsle.TIGameSession:bServerWhitelist";

const createMenu = (): Menu => {
  const menu = defaultProfile().menu;
  menu[0].items.push(commonMenuItems.logs);
  return menu;
};

const configSections: ConfigSection[] = [
  { component: "TheIslePasswordNotice", props: { message: "ngp/theisleevrima/password/notice" } },
  { component: "ConfSection", props: { name: "basic" } },
  { component: "ConfSection", props: { name: "extended" } },
  {
    component: "TableSection",
    props: { name: "whitelist", visibleIf: { config: "game", field: WHITELIST_ENABLED_KEY, value: "true" } },
  },
  { component: "TableSection", props: { name: "vipList" } },
  { component: "TableSection", props: { name: "mutationList" } },
  { component: "TableSection", props: { name: "adminList" } },
  { component: "ConfSection", props: { name: "modding" } },
];

export default (_ctx: ProfileCtx): Partial<GameProfile> => ({
  menu: createMenu(),
  configSections,
});
